<svelte:head>

    <link rel='stylesheet' href='/global.css' />

</svelte:head>

<script>

    import {
        HS_API_URL,
        getOrderDetails,
        getOrderCodes,
        createDynamicLink,
        getMergedPdf,
        triggerPdfCreation
    } from "./api.svelte";

    import { onMount } from "svelte";

    import dayjs from "dayjs";


    export let orderKey = false;

    let orderDetails = false;
    let orderCodes = false;

    let bulkOrder = false;
    let codesIds = false;
    let bulkPdf = false;


    onMount(() => {

        handleOrderDetails();

    });

    let handleOrderDetails = () => {

        getOrderDetails(orderKey).then((detailsResult) => {

            if (detailsResult['status'] !== 'success') {

                console.log(detailsResult);
                return;

            }

            orderDetails = detailsResult['details'];
            console.log(orderDetails);

            if (orderDetails['status'] === 'completed' || orderDetails['status'] === 'on-hold') {

                handleOrderCodes();

            }

        });

    };

    let handleOrderCodes = () => {

        getOrderCodes(orderKey).then((codesResult) => {

            if (codesResult['status'] !== 'success') {

                console.log(codesResult);
                return;

            }

            orderCodes = codesResult['qrcodes'];

            codesIds = Object.keys(orderCodes)

            if (codesIds.length >= 11) {

                bulkOrder = true;

                // Trigger PDF creation for all codes
                const pdfCreationPromises = codesIds.map(codeId => triggerPdfCreation(codeId));

                // Wait for all PDFs to be created
                Promise.all(pdfCreationPromises).then(() => {
                    // Fetch merged PDF
                    return getMergedPdf(orderKey, codesIds);
                }).then((pdfBlob) => {
                    // Download merged PDF
                    downloadPdf(pdfBlob, 'codes.pdf');
                }).catch((error) => {
                    console.error('Error:', error);
                });

            }


            console.log(orderCodes)

        });

    };

    let downloadPdf = (pdfblob) => {

        // Create a Blob URL
        const downloadUrl = window.URL.createObjectURL(pdfblob);

        // Create a link element
        const link = document.createElement('a');

        // Set the download attribute with a filename
        link.download = 'ab-codes.pdf';

        // Set the href attribute with the Blob URL
        link.href = downloadUrl;

        // Append the link to the body
        document.body.appendChild(link);

        // Simulate a click to trigger the download
        link.click();

        // Remove the link from the body
        document.body.removeChild(link);

        // Optionally: Revoke the blob URL to release memory
        window.URL.revokeObjectURL(downloadUrl);
    }

    let getAmount = (rawAmount) => {

        return rawAmount.replace( /^\D+/g, '');

    }

    $: getTotalAmount = () => {

        let total = 0;

        for (const [id, item] of Object.entries(orderDetails['items'])) {

            let formattedAmount = item['sku'].replace( /^\D+/g, '');

            for (let i = 0; i < item['quantity']; i++) {

                total += parseInt(formattedAmount);
            }

        }

        return total;
    }

    let isMobile = () => {

        let check = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
        return check;
    }

    let saveToClipboard = (code, e) => {

        let DYNAMIC_BASE_URL = "https://aemtlerbon.onelink.me/8hqN/elm8d780?deep_link_value=voucher&deep_link_sub1="

        let link = DYNAMIC_BASE_URL + code

        let button = e.target;

        button.innerHTML = '<img class="button-done" src="/assets/correct.svg" style="height: 3vh"/>'

        navigator.clipboard.writeText(link);

    }

</script>


<div id="overview-container">

    {#if !orderDetails}

        <h1>Wird geladen ...</h1>

    {:else}
        
        <div id="header">
            
            <div id="logo">

                <img src="/assets/logo.png" alt="">
            </div>

            <div id="headline">

                <h1>Bestellbestätigung und Gutschein</h1>

            </div>

        </div>

        <div id="main-container">

            <div id="main-wrapper">

                <div id="details">

                    <div class="column space-bottom">

                        <strong>Bestellung #{orderDetails['id']} vom {dayjs(orderDetails['created'] * 1000).format('DD.MM.YYYY')}</strong>

                    </div>

                    <div class="column space">
                        {#each Object.entries(orderDetails['items']) as [id, detail]}

                            {#each Array(detail['quantity']) as num}
                                <span>Gutschein Ämtler-Bon, CHF {getAmount(detail['sku'])}.-</span>
                            {/each}

                        {/each}
                    </div>

                    <div class="space">

                        <strong>Total CHF {getTotalAmount()}.-</strong>

                    </div>

                    <span style="margin-top: 1vh">Vielen Dank für Ihre Bestellung</span>

                    <!--{#if !bulkOrder}-->

                    <!--    <div class="column space-top">-->

                    <!--        <strong>Hier können Sie den Gutschein direkt auf Ihr Smartphone laden</strong>-->
                    <!--        <hr class="solid">-->


                    <!--    </div>-->

                    <!--{:else}-->

                    <!--    <div class="column space-top">-->

                    <!--        <strong>Das PDF wird automatisch heruntergeladen</strong>-->
                    <!--        <hr class="solid">-->


                    <!--    </div>-->

                    <!--{/if}-->



                </div>

                <div class="divider">
                    <hr>
                </div>

                {#if !bulkOrder}

                    <div id="codes-container">

                        {#if orderCodes}

                            <div class="codes-title">

                                <strong>Mit der Ämtler Bon App den QR-Code scannen und alle Gutscheine direkt in der App hinterlegen</strong>

                            </div>

                            <div id="codes">

                                {#each Object.entries(orderCodes) as [codeId, code]}

                                    <div class="code">

                                        <img class="code" src="data:image/png;base64,{code['img']}" alt="QR-Code" />

                                    </div>

                                {/each}

                            </div>

                            <div class="storedownload">

                                <span>Ämtler Bon App für Apple iOS oder Android downloaden</span>

                                <div class="stores-images">

                                    <a href="https://apps.apple.com/ch/app/%C3%A4mtler-bon/id6444159853" target="_blank"><img src="/assets/appstore.svg" alt="appstore logo"></a>
                                    <a href="https://play.google.com/store/apps/details?id=ch.voima.aemtlerbon&hl=gsw" target="_blank"><img src="/assets/playstore.png" alt="playstore logo"></a>
                                </div>

                            </div>

                            <div class="divider">
                                <hr>
                            </div>

                            <div class="pdfdownload-container">

                                <strong>Gutschein als PDF</strong>

                                <div class="pdflink-container space-top">
                                    {#each Object.entries(orderCodes) as [codeId, code], i}

                                        <div class="icon-link">
                                            <button type="button"><a href="{window.apiUrl}/codes/pdf?code={codeId}" target="_blank">Gutschein Nr.{i + 1}<br><span>Download</span></a></button>

                                        </div>

                                    {/each}
                                </div>

                            </div>

                            <div class="divider">
                                <hr>
                            </div>

                            <div class="space dynamiclink-container">

                                <strong>Gutschein als Download-Link</strong>

                                <span>Link mit dem Smartphone kopieren und direkt in der Horgener Schwan App hinterlegen</span>

                                <div class="dynamiclink-wrapper">

                                    {#each Object.entries(orderCodes) as [codeId, codeData], i}

                                        {#if isMobile()}

                                            <div class="space">

                                                <button type="button"><a href="https://aemtlerbon.onelink.me/8hqN/elm8d780?deep_link_value=voucher&deep_link_sub1={codeId}" target="_blank">Gutschein ({i + 1})<br><span>in App importieren</span></a></button>

                                            </div>

                                        {:else}

                                            <div class="space-top">

                                                <button type="button" value="clipboard" on:click={(e) => saveToClipboard(codeId, e)}>Gutschein Nr. {i + 1}<br><span>Link kopieren</span></button>

                                            </div>

                                        {/if}

                                    {/each}
                                </div>



                            </div>

                        {/if}

                    </div>

                {:else}

                    <div class="column space-top">

                        <strong>Das PDF mit den Gutscheinen wird automatisch heruntergeladen</strong>

                    </div>

                {/if}

                <div class="divider">
                    <hr>
                </div>

                <div class="space text-container">

                    <div class="space">

                        <strong>Wir wünschen Ihnen schönes Shopping im Bezirk Affoltern mit dem Ämtler-Bon.<br>Ihr KMU- und Gewerbeverband Bezirk Affoltern</strong>

                    </div>

                    <div class="space">

                        <span>
                            <strong>Haben Sie noch Fragen zum Gutschein?</strong><br>
                            Wir haben Ihnen eine kurze
                            <a href="https://info.aemtler-bon.ch" target="_blank" class="link">Anleitung</a>
                            zusammengestellt. Viele Fragen beantworten wir in unseren
                            <a href="https://info.aemtler-bon.ch" target="_blank" class="link">Frage&Antwort-Bereich</a>.
                            Ausserdem steht Ihnen unsere ausführliche Hilfe auf <a href="https://info.aemtler-bon.ch">info.aemtler-bon.ch</a> zur Verfügung.
                        </span>

                    </div>

                    <div class="space-double">

                        <span>
                            <a href="https://aemtler-bon.ch" class="link">Aemtlerbon.ch</a> <br>
                            Herausgegeben von: KMU- und Gewerbeverband Bezirk Affoltern, Standortförderung Knonauer Amt und Arbeitgeberverband Bezirk Affoltern.
                        </span>

                    </div>

                    <div>

                        <span><a href="mailto:">Support: info.aemtlerbon.ch</a></span> <br>
                        <span>Entwicklung und Betrieb durch VOIMA gmbh, <a href="https://voima.ch" target="_blank">voima.ch</a></span>

                    </div>

                </div>

<!--                {#if bulkOrder}-->

<!--                    <div id="codes">-->

<!--                        {#if codesIds}-->

<!--&lt;!&ndash;                            <div class="code">&ndash;&gt;-->

<!--&lt;!&ndash;                                <img class="code" src="/assets/pdf.svg" alt="Pdf Icon" />&ndash;&gt;-->

<!--&lt;!&ndash;                                <hr class="solid" style="width: 90%">&ndash;&gt;-->

<!--&lt;!&ndash;                                <div class="icon-link">&ndash;&gt;-->
<!--&lt;!&ndash;                                    <img class="download-icon" src="/assets/download.svg" alt=""><a href="{HS_API_URL}/codes/pdf?code={codeId}" target="_blank">Download als PDF</a>&ndash;&gt;-->
<!--&lt;!&ndash;                                </div>&ndash;&gt;-->

<!--&lt;!&ndash;                            </div>&ndash;&gt;-->

<!--                        {/if}-->
<!--                    </div>-->

<!--                {:else}-->

<!--                    <div id="codes">-->

<!--                        {#if orderCodes}-->

<!--                            {#each Object.entries(orderCodes) as [codeId, code]}-->

<!--                                <div class="code">-->

<!--                                    <img class="code" src="data:image/png;base64,{code['img']}" alt="QR-Code" />-->

<!--                                    <hr class="solid" style="width: 90%">-->

<!--                                    <div class="icon-link">-->
<!--                                        <img class="download-icon" src="/assets/download.svg" alt=""><a href="{window.apiUrl}/codes/pdf?code={codeId}" target="_blank">Download als PDF</a>-->
<!--                                    </div>-->

<!--                                </div>-->

<!--                            {/each}-->

<!--                        {/if}-->

<!--                    </div>-->

<!--                    <div class="space dynamiclink-container">-->

<!--                        {#each Object.entries(orderCodes) as [codeId, codeData], i}-->

<!--                            {#if isMobile()}-->

<!--                                <div class="space">-->

<!--                                    <a href="{codeData['dynamiclink']}" target="_blank">Gutschein ({i + 1}) in App importieren</a>-->

<!--                                </div>-->

<!--                            {:else}-->

<!--                                <div class="space-top">-->

<!--                                    <button type="button" value="clipboard" on:click={(e) => saveToClipboard(codeData['dynamiclink'], e)}>Gutscheinlink kopieren, Nr. {i + 1}</button>-->

<!--                                </div>-->

<!--                            {/if}-->

<!--                        {/each}-->

<!--                    </div>-->

<!--                {/if}-->



<!--                <div class="space text-container">-->

<!--                    <div class="space">-->

<!--                        <span>Wir wünschen Ihnen schönes Shopping im Bezirk Affoltern mit dem Ämtler-Bon.</span>-->

<!--                    </div>-->

<!--                    <div class="space-double">-->
<!--                        <strong>Ihr KMU- und Gewerbeverband Bezirk Affoltern</strong>-->
<!--                    </div>-->

<!--                    <div class="space">-->

<!--                        <span>-->
<!--                            Haben Sie noch Fragen zum Gutschein?-->
<!--                            Wir haben Ihnen eine kurze-->
<!--                            <a href="info.aemtler-bon.ch" class="link">Anleitung</a>-->
<!--                            zusammengestellt. Viele Fragen beantworten wir in unseren-->
<!--                            <a href="info.aemtler-bon.ch" class="link">Frage&Antwort-Bereich</a>.-->
<!--                            Ausserdem steht Ihnen unsere ausführliche Hilfe auf info.aemtler-bon.ch zur Verfügung.-->
<!--                        </span>-->

<!--                    </div>-->

<!--                    <div class="space-double">-->

<!--                        <span>-->
<!--                            <a href="aemtler-bon.ch" class="link">Aemtlerbon.ch</a> <br>-->
<!--                            Herausgegeben von: KMU- und Gewerbeverband Bezirk Affoltern, Standortförderung Knonauer Amt und Arbeitgeberverband Bezirk Affoltern.-->
<!--                        </span>-->

<!--                    </div>-->

<!--                    <div>-->

<!--                        <span>Support: info.aemtlerbon.ch</span> <br>-->
<!--                        <span>Entwicklung und Betrieb durch VOIMA gmbh, voima.ch</span>-->

<!--                    </div>-->

<!--                </div>-->

            </div>

        </div>

    {/if}

</div>


<style>

    #overview-container {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #EDEDED;
    }

    #header {
        width: 100%;
        display: flex;
        align-items: end;
        background: #787878;
        height: 11vh;
    }

    #header #logo {
        position: absolute;
        transform: translate(0, 40%);
    }

    #header #logo img {
        width: 9vh;
        height: 9vh;
        margin-right: 5vh;
        margin-left: 2.5vh;
        border-radius: 1vh;
    }

    #header #headline {
        padding-left: 16.5vh;
        padding-bottom: 1vh;
    }

    #header img {

    }

    #main-container {
        height: 100%;
    }

    #main-wrapper {
        width: inherit;
        padding-left: 16.5vh;
        margin-top: 4vh;
    }

    #details {
        width: max-content;
        display: flex;
        flex-direction: column;
    }

    .column {
        display: flex;
        flex-direction: column;
    }

    .solid {
        width: 100%;
    }

    .space {
        margin: 1vh 0;
    }

    .space-top {
        margin-top: 1.5vh;
    }
    .space-bottom {
        margin-bottom: 1vh;
    }

    h1 {
        font-size: 2vh;
        font-weight: 700;
        text-align: center;
        color: white;
        font-family: 'Raleway', sans-serif;
    }
    span, strong, a {
        color: black;
        line-height: 2vh;
        font-family: 'Raleway', sans-serif;
    }
    strong {
        font-weight: 700;
    }

    span, a, strong {
        font-weight: 400;
        font-size: 1.5vh;
    }

    strong {
        font-weight: 600;
        font-size: 1.5vh;
    }

    #codes {
        display: flex;
        flex-direction: row;
        width: 100%;
        flex-wrap: wrap;
    }

    .code {
        display: flex;
        flex-direction: column;
    }

    .code img {
        display: flex;
        max-width: 20vh;
    }

    .code .icon-link a {
        font-family: 'Raleway', sans-serif;
        font-size: 1.4vh;
        font-weight: 400;
        color: black;
        text-align: center;
        display: flex;
        align-items: center;
        transition: 0.3s ease;
    }

    .code .icon-link a:hover {
        transform: scale(1.03);

    }

    .icon-link {
        display: flex;
        flex-direction: row;
    }

    .code .download-icon {
        filter: none;
        margin: 0 1vh;
    }

    .code .download-icon {
        height: 2vh;
    }

    .text-container {
        width: 45%;
        margin-top: 3vh;
        padding-bottom: 10vh;
    }

    .link {
        font-weight: 500;
        color: black;
        text-decoration: none;
    }

    .space-double {
        margin: 1.5vh 0;
    }

    .dynamiclink-container {
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
    }

    button {
        border: none;
        color: black;
        font-weight: 600;
        font-size: 1.5vh;
        padding: 1vh;
        width: 20vh;
        margin: 0 1vh 1vh 0;
        cursor: pointer;
        transition: 0.3s ease;
        background-color: #F9E926FF;
    }

    button a {
        font-weight: 600;
    }

    button a span, button span {
        font-weight: 400;
    }

    button:hover {
        transform: scale(1.03);
    }

    .button-done {
        height: 3vh;
    }

    button img {
        height: 3vh;
    }

    .divider {
        width: 30%;
        margin: 3vh 0;
    }

    .codes-title {
        width: 20%;
        margin-bottom: 2vh;
    }

    .storedownload {
        margin-bottom: 3vh;
        margin-top: 2vh;
    }

    .stores-images {
        width: 4vh;
        height: 4vh;
        display: flex;
        margin-top: 2vh;
    }

    .stores-images img {
        height: 100%;
        margin-right: 1vh;
    }

    strong {
        font-weight: 600;
    }

    .pdflink-container {
        display: flex;
        flex-wrap: wrap;
    }

    .dynamiclink-wrapper {
        display: flex;
        flex-wrap: wrap;
    }



    @media (max-width: 1024px) {

        #overview-container {
            height: auto;
        }

        #header {
            height: 25vw;
            justify-content: space-evenly;
            align-items: center;
        }

        #header #headline {
            padding-left: 0;
            padding-bottom: 0;
        }

        #header #logo {
            position: relative;
            transform: none;
        }

        #header #logo img {
            height: 10vw;
            margin: unset;
            width: unset;
        }

        #header #headline h1 {
            font-size: 5vw;
        }
        span, a, strong {
            font-size: 3.3vw;
        }

        #main-container #main-wrapper {
            padding: 4vw 3vw 4vw 3vw;
            margin: unset;
            background-color: #EDEDED;
        }

        #main-container #main-wrapper #details {
            width: 100%;
        }

        #main-container #main-wrapper #codes {
            justify-content: center;
        }
        #main-container #main-wrapper .text-container {
            width: 100%;
        }

        .code .icon-link a {
            font-size: 3.5vw;
        }

        .space {
            margin: 3vw 0;
        }

        .space-top {
            margin-top: 3vw;
        }

        .space-bottom {
            margin-bottom: 3vw;
        }

        .dynamiclink-container {
            justify-content: center;
        }

        .codes-title {
            width: 100%;
        }

        .dynamiclink-container a {
            font-weight: 700;
            font-size: 4vw;
        }

    }

</style>
